export enum ProgressBarAppearance {
  Positive = 'positive',
  Negative = 'negative',
  Neutral = 'neutral',
}
